import ReactDOM from "react-dom"
import { CanvasClient } from "@app/page-components/app/canvas";
import ContextMenuWidget from "../widgets/ContextMenuWidget";
import Utility from "./Utility"; 
import { Constant } from "../const";

/**
 * Manages canvas tabs provided by w2ui
 * @module CanvasTabManager
 */

export default class CanvasTabManager {
	static initTabs($w2ui_tabs) {
		$($w2ui_tabs.box).on("contextmenu", event => {
			if (event.target.classList.contains("w2ui-tab")) {
				event.preventDefault()
				if (event.target.classList.contains("closable")) {
					CanvasTabManager.openContextMenu(event)
				}
			}
		});
	}

	/**
	 * Sortable adds drag sorting of canvas tabs
	 */
	static initSortable() {
		// TODO: _rootModule and tabs_layout_main_tabs_right cannot be dragged, but their positions may change when another tab is dragged
		// potential fix is to explicitly set their order/position in the tabs table row
		// sortable configures canvas tabs to be draggable
		$(".w2ui-tabs > div.w2ui-scroll-wrapper > table > tbody > tr").sortable({
			axis: 'x',
			items: "td:not(.ui-sortable-handle)",
			cancel: ".ui-sortable td[id$=_rootModule], .ui-sortable td[id=tabs_layout_main_tabs_right]",
			placeholder: 'tab-placeholder',

			// triggered when sorting starts.
			start: (event, ui) => {
				const item = ui.item;
				const placeholder = $(ui.placeholder);

				const div = $('<div>');
				$(div).width($(item).width());
				$(div).height($(item).height());

				$(div).appendTo(placeholder);

			},
			// triggered when sorting has stopped.
			stop: (event, ui) => {
				window.apm.isScrolling = false;
				const tabCollection = [...document.getElementsByClassName('ui-sortable')[0].children];
				const w2uiTabs = w2ui.layout.get("main").tabs.tabs;
				const toIndex = tabCollection.findIndex(item => item === ui.item[0]);
				const fromIndex = w2uiTabs.findIndex(item => item.text === ui.item[0].children[1].textContent);

				w2ui.layout.get("main").tabs.tabs.splice(toIndex, 0, w2ui.layout.get("main").tabs.tabs.splice(fromIndex, 1)[0]);
				this.updateSavedTabs();
			},
			sort: (event, ui) => {
				// there should not be more than one of these but there are...
				const rightScroll = $('.w2ui-scroll-right')[0];
				const rightScrollCoords = rightScroll.getBoundingClientRect();
				// there should not be more than one of these but there are...
				const leftScroll = $('.w2ui-scroll-left')[0];
				const leftScrollCoords = leftScroll.getBoundingClientRect();

				
				if (!window.apm.isScrolling && event.pageX >= rightScrollCoords.left) {
					$(rightScroll).trigger("click");
					window.apm.isScrolling = true;
				}

				if (!window.apm.isScrolling && event.pageX <= leftScrollCoords.right) {
					$(leftScroll).trigger("click");
					window.apm.isScrolling = true;
				}
			}
		});
	}

	static handleTabsOnClick(event) {
		const canvasDom = $("#canvas");
		const canvasId = event.target + "_canvas";
		// CM TODO: module versions and flowVersion: remove or refactor version
		const version = event.tab.version || 1
		const node = window.apm.getNode(event.target);
		const tab = this.getTabs().tabs.find(tab => tab.id === event.target);
		
		canvasDom.find(".tab").hide() // jquery hides all canvases
		window.apm.serialized.currentActiveTab = event.target

		window.apm.setSerializedChanged();

		if (!$("#" + canvasId).length) {
			canvasDom.append('<div id="' + canvasId + '" class="tab"></div>');
			
			const clientInstance = ReactDOM.render(
				<CanvasClient 
					node={node} 
					clientId={canvasId}
					version={version} />,
				document.getElementById(canvasId)
			)
			window.apm.cache.put(
				Constant.k.NAMESPACE_CLIENT,
				canvasId,
				clientInstance
			)
		}
		$("#canvas #" + event.target + "_canvas").show(100, () => {

			const clientInstance = window.apm.cache.get(
				Constant.k.NAMESPACE_CLIENT,
				canvasId
			)
			if (clientInstance) {
				clientInstance.updateFocus()
			}
			if(tab.repoVersion!==window.apm.serialized.repoVersion){
				this.reloadModule()
			}
		});

	}

	static handleTabsOnClose(event, context) {
		setTimeout(() => {
			this.closeCurrentModule(event.target)
		}, 220)
		window.apm.removeValidationError(event.target)
	}

	static openContextMenu(event) {
		const contextContainer = $(".context_menu")
		const tabId = event.target.parentElement.id.replace(
			/tabs_layout_main_tabs_tab_/gi,
			""
		);

		ReactDOM.render(
			<ContextMenuWidget
				context={this}
				pos={{ top: event.clientY, left: event.clientX }}
				type={"canvastab"}
				domContext={contextContainer}
				tabId={tabId}
			/>,
			contextContainer.get(0)
		)
	}

	static renameTab(id, name) {
		const tabs = this.getTabs()

		for (var i = 0; i < tabs.tabs.length; i++) {
			const tab = tabs.tabs[i]
			if (id === tab.moduleId) {
				tab.text = name
				tabs.refresh(tab.id)
			}
		}

		this.updateSavedTabs();
	}

	static updateTabRepoVersion(id, repoVersion) {
		const tab = this.getTabs().tabs.find(tab => tab.id === id)
		tab.repoVersion = repoVersion;
	}

	static addTab(node) {
		const tabs = this.getTabs()
		const scrollRight = document.querySelector(".w2ui-scroll-right")
		let newTab = {}

		if (tabs.get(node.id) === null) {
			// CM TODO: module versions and flowVersion: remove or refactor version
			newTab = {
				id: node.id,
				name: node.id,
				moduleId: node.id,
				text: node.text || node.name,
				closable: true,
				version: node.version || 1,
				repoVersion: window.apm.serialized.repoVersion
			};
			tabs.add(newTab);

			this.updateSavedTabs();
		}
		
		// hide the preview from $jstree
		window.apm.postEventToCurrentView({ target: "request-cancel-preview" })
		// when opening a new tab, show Loading Module message in app overlay
		Utility.openApplicationOverlay('Loading Module...');
		
		// click srcollRight element if it is visible to scroll new tab into view
		if (
			scrollRight &&
			scrollRight.style.display !== "none" &&
			scrollRight.style.display === "block"
		) {
			scrollRight.click()
		}

		this.setTab(node.id)

		Utility.closeApplicationOverlay();

	}

	static removeTab(tabId, nextTabId = null) {
		const canvasId = tabId + "_canvas";
		const tabs = this.getTabs();
		const clientCanvasInstance = $("#"+canvasId)[0];
		
		tabs.remove(tabId); // remove tabs from w2ui
		this.updateSavedTabs(); // update tabs in localStorage

		// unmount CanvasClient component instance (module canvas)
		if(clientCanvasInstance) {
			ReactDOM.unmountComponentAtNode(clientCanvasInstance);
		}

		// remove DOM instance
		$("#" + canvasId).remove();

		// remove from app cache
		window.apm.cache.remove(Constant.k.NAMESPACE_CLIENT, canvasId);
		window.apm.cache.remove(Constant.k.NAMESPACE_DIAGRAM_WIDGET, canvasId);
		
		// set up next tab if proveded
		if (nextTabId) {
			tabs.click(nextTabId);
		}
	}

	static insertTab(beforeTabId, newTab) {
		this.getTabs().insert(beforeTabId, newTab)
		$("#" + beforeTabId + "_canvas").remove()
		this.setTab(newTab.id)
	}

	static getTabs() {
		return w2ui.layout.get("main").tabs
	}

	static setTab(id) {
		return this.getTabs().click(id);
	}

	/**
	 * close selected tab get next tab in tabs array and select it
	 * @param {number} id
	 */
	static closeCurrentModule(id) {
		const tabs = this.getTabs()
		const tabIndex = tabs.tabs.findIndex(tab => id === tab.moduleId)
		const currentActiveTabIndex = tabs.tabs.findIndex(
			tab => window.apm.serialized.currentActiveTab === tab.moduleId
		)
		
		let nextTabIdx = currentActiveTabIndex
		
		if (tabIndex === currentActiveTabIndex) {
			if (tabIndex < tabs.tabs.length - 1) {
				nextTabIdx = tabIndex + 1;
			} else {
				nextTabIdx = tabIndex - 1;
			}
		}

		if (tabIndex !== -1) {
			this.removeTab(tabs.tabs[tabIndex].id, tabs.tabs[nextTabIdx].id)
		}
	}

	/**
	 * close all tabs except the first one, set first tab active
	 */
	static closeAllModules(event) {
		const tabContainer = this.getTabs()
		const closable = []

		tabContainer.tabs.forEach(tab => {
			if (tab.closable) {
				closable.push(tab.id)
				const canvasId = tab.id + "_canvas"
				$("#" + canvasId).remove()
				window.apm.cache.remove(Constant.k.NAMESPACE_CLIENT, canvasId)
			}
		})

		tabContainer.remove.apply(tabContainer, closable)

		this.setTab("rootModule")
		this.updateSavedTabs();
	}

	/**
	 * close all module tabs except selected, set this tab to active
	 * @param {number} id
	 */
	static closeOtherModules(id) {
		const tabContainer = this.getTabs()
		const closable = []

		tabContainer.tabs.forEach(tab => {
			if (tab.closable && tab.id !== id) {
				closable.push(tab.id)
				const canvasId = tab.id + "_canvas"
				$("#" + canvasId).remove()
				window.apm.cache.remove(Constant.k.NAMESPACE_CLIENT, canvasId)
			}
		})

		tabContainer.remove.apply(tabContainer, closable)

		this.setTab(id)
		this.updateSavedTabs();
	}

	/**
	 * close tabs with index greater than selected tab, set this tab to active
	 * @param {Number} id
	 */
	static closeModulesToRight(id) {
		const tabContainer = this.getTabs()
		const idx = tabContainer.tabs.findIndex(tab => tab.id === id)
		let closable = []

		tabContainer.tabs.slice(idx + 1).forEach(tab => {
			if (tab.closable) {
				closable.push(tab.id)
				const canvasId = tab.id + "_canvas"
				$("#" + canvasId).remove()
				window.apm.cache.remove(Constant.k.NAMESPACE_CLIENT, canvasId)
			}
		})

		tabContainer.remove.apply(tabContainer, closable)

		if (
			tabContainer.tabs.find(
				tab => tab.id === window.apm.serialized.currentActiveTab
			)
		) {
			this.setTab(window.apm.serialized.currentActiveTab)
		} else {
			this.setTab(id)
		}

		this.updateSavedTabs();
	}

	static closeModulesToLeft(id) {
		const tabContainer = this.getTabs()
		const idx = tabContainer.tabs.findIndex(tab => tab.id === id)
		let closable = []
		tabContainer.tabs.slice(0, idx).forEach(tab => {
			if (tab.closable) {
				closable.push(tab.id)
				const canvasId = tab.id + "_canvas"
				$("#" + canvasId).remove()
				window.apm.cache.remove(Constant.k.NAMESPACE_CLIENT, canvasId)
			}
		})

		tabContainer.remove.apply(tabContainer, closable)

		if (
			tabContainer.tabs.find(
				tab => tab.id === window.apm.serialized.currentActiveTab
			)
		) {
			this.setTab(window.apm.serialized.currentActiveTab)
		} else {
			this.setTab(id)
		}

		this.updateSavedTabs();
	}
	/**
	 * reload the current open tab
	 */
	static reloadModule(){
		// inform user that reload is happening
		Utility.openApplicationOverlay("Reloading Module...");

		const minimumTmer = new Promise((resolve, reject) => {
			setTimeout(() => {
				resolve()
			}, 1000);
		});

		const reloadDataModel = new Promise((resolve, reject) => {
			window.apm.postEventToCurrentView({ target: "request-reload-data-model"});
			window.apm.postEventToCurrentView({ target: "request-update-member", commands: {hidePropertyPanel: true} });
			resolve();
		});

		// allow for a minimum of one second before removing overlay
		Promise.all([reloadDataModel, minimumTmer]).then(() => {
			Utility.closeApplicationOverlay();
		});
	}
	/**
	 * copy the moduleName to the clipboard 
	 * @param {string} moduleName 
	 */
	static copyModuleName(moduleName){
			let el = document.createElement('input');
			el.value = moduleName;
			el.setAttribute('readonly', '');
			el.style = {position: 'absolute', left: '-9999px'};
			document.body.appendChild(el);
			el.select();
			// Copy text to clipboard
			document.execCommand('copy');
			// Remove temporary element
			document.body.removeChild(el); 
	}

	/**
	 * Update `savedTabs` with the current opened tabs
	 * @returns {undefined}
	 */
	 static updateSavedTabs() {
		const w2uiTabs = this.getTabs().tabs;
		const tabs = w2uiTabs.filter(tab => tab.id !== "rootModule");

		this.setSavedTabs(tabs);

		return;
	}

	/**
	 * Set `tabs` into `savedTabs` by client and application
	 * @param {Array} tabs
	 * @returns {undefined}
	 */
	static setSavedTabs(tabs) {
		const { client, application } = window.apm.serialized;
		const savedTabs = JSON.parse(localStorage.getItem('savedTabs')) || {};

		// safe check for undefined `client` inside `savedTabs`
		if (!savedTabs[client]) {
			savedTabs[client] = {
				[application]: tabs
			}
		} else {
			savedTabs[client][application] = tabs;
		}

		const savedTabsJson = JSON.stringify(savedTabs);
		localStorage.setItem('savedTabs', savedTabsJson);

		return;
	}

	/**
	 * Get client application tabs out from `savedTabs`
	 * @returns {Array}
	 */
	static getSavedTabs() {
		const { client, application } = window.apm.serialized;
		const savedTabs = JSON.parse(localStorage.getItem('savedTabs')) || {};

		return savedTabs[client] ? savedTabs[client][application] : [];
	}
}
